import React from 'react';
import { useMetaContent } from '../../model/meta';
import { Text } from '../text/text';
import './breadcrumbs.scss';
import { Link } from 'react-router-dom';

export function Breadcrumbs(): JSX.Element {
  const { breadcrumbs } = useMetaContent();

  return (
    <ul className="breadcrumbs">
      {breadcrumbs?.map((crumb, index) => {
        return (
          <li className="breadcrumbs__item" key={index}>
            {crumb.url ? (
              <Link to={crumb.url}>
                <Text type={crumb.url ? 'breadcrumb' : 'breadcrumb-active'}>
                  <div className="breadcrumbs__breadcrumb">{crumb.title}</div>
                </Text>
              </Link>
            ) : (
              <Text type={crumb.url ? 'breadcrumb' : 'breadcrumb-active'}>{crumb.title}</Text>
            )}
          </li>
        );
      })}
    </ul>
  );
}
